import { GlobalNavigation, HeaderShadowWrapper, intoNavigationItems } from 'ui-toolkit';
import React from 'react';
import messages from '../utils/messages';
import { clientUrls } from '../../ui-toolkit/rest/ClientUrlFactory';
import { useHasFeatureFlag } from '../../selectors/useHasFeatureFlag';

export interface IPageHeaderProps {
  active: string;
  onHomeClick: () => void;
}

export const PageHeader: React.FC<IPageHeaderProps> = ({ active, onHomeClick }) => {
  const navigationItems = [
    {
      to: clientUrls.urlFor.clientOrders(),
      text: messages.navigation.orders,
      key: messages.navigation.orders,
    },
  ].map(intoNavigationItems);
  const isZillowClosingEnabled = useHasFeatureFlag('pinecone.zillow-closing');

  return (
    <HeaderShadowWrapper useDefaultBackground={isZillowClosingEnabled}>
      <GlobalNavigation
        onHomeClick={onHomeClick}
        showActions={true}
        active={messages.navigation[active]}
        isLogoLink={true}
      >
        {navigationItems}
      </GlobalNavigation>
    </HeaderShadowWrapper>
  );
};
